import { registerAccountMenu } from "./account-menu.js";
import { registerLegalAcceptanceNotice } from "./legal-acceptance-notice.js";
import { registerAccountAvatarPicker } from "./account-avatar-picker.js";
import { registerAccountSession } from "./account-session.js";
import { registerCheckboxGroup } from "./checkbox-group.js";
import { registerConsentCenter } from "./consent-center.js";
import { registerDistributionChart, registerTimelineChart } from "./distribution-chart.js";
import { attachGuideLinkPreviews } from "./guide-link-preview.js";
import { registerLootSankey } from "./loot-sankey.js";
import { registerNoticeDisclosure } from "./notice-disclosure.js";
import { registerPageHealthMenu } from "./page-health-menu.js";
import { registerPresetManager } from "./preset-manager.js";
import { registerPresetQuickSwitch } from "./preset-quick-switch.js";
import { registerPmfChart } from "./pmf-chart.js";
import { attachProvenanceTooltip } from "./provenance-tooltip.js";
import { registerSearchableDropdown } from "./searchable-dropdown.js";
import { registerSearchableMultiselect } from "./searchable-multiselect.js";
import { registerScrollToTop } from "./scroll-to-top.js";
import { attachStatBreakdownTooltip } from "./stat-breakdown-tooltip.js";
import { attachSiteTooltip } from "./site-tooltip.js";
import { attachNoticeDisclosurePreferences } from "../notice-disclosure-controller.js";

registerAccountAvatarPicker();
registerAccountMenu();
registerLegalAcceptanceNotice();
registerAccountSession();
registerCheckboxGroup();
registerConsentCenter();
registerDistributionChart();
registerLootSankey();
registerNoticeDisclosure();
registerPageHealthMenu();
registerPresetManager();
registerPmfChart();
registerTimelineChart();
registerSearchableDropdown();
registerSearchableMultiselect();
registerScrollToTop();
registerPresetQuickSwitch();
if (typeof document !== "undefined") {
    attachNoticeDisclosurePreferences(document);
    attachSiteTooltip(document);
    attachGuideLinkPreviews(document);
    attachProvenanceTooltip(document);
    attachStatBreakdownTooltip(document);
}
